@if (isin) {
  @if (isFeatureActive) {
    <a [class]="linkCssClass" [routerLink]="url" [queryParams]="queryParams">
      <ng-container *ngTemplateOutlet="label" />
    </a>
  } @else {
    <a [class]="linkCssClass" [href]="url" target="_blank" rel="noopener noreferrer">
      <ng-container *ngTemplateOutlet="label" />
    </a>
  }
}

<ng-template #label>
  <ng-content />
</ng-template>
